const LOGO =
  "https://customer-assets-v7afamib.emergentagent.net/job_fbf41b09-d279-44ec-b80d-da1d7a743c90/artifacts/84dz6r0l_Zapin-New-Logo-TM-White-2048x1749.webp";

export const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
    <div className="flex flex-col items-center gap-5">
      <img src={LOGO} alt="Zapin" className="h-16 w-auto opacity-90" />
      <div className="hairline shimmer w-24" />
      <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Loading analytics</div>
    </div>
  </div>
);
